/* eslint formatjs/no-literal-string-in-jsx: "error" */
import { SinglePathSVG } from "components/views/SVG"
import React, { FC, ReactElement } from "react"
import styled from "styled-components"
import Breadcrumb from "./Breadcrumb"
import { Header } from "./Header"
import { useBreakpointComponent, Divider, FlexContainer, Container } from "@carrotfertility/carotene"

const Chevron = styled(SinglePathSVG).attrs({ className: "black-60" })`
  margin: 0px 11px;
`

const CrumbsContainer = styled.div.attrs({ className: "flex items-center" })``

const seperator = <Chevron icon="rightCarrotSmall" />

type BreadcrumbsHeaderProps = {
  breadcrumbs: ReactElement<typeof Breadcrumb>[]
}

const AllCrumbs = ({ breadcrumbs }: BreadcrumbsHeaderProps) => {
  return breadcrumbs.reduce((display, crumb) => (
    <>
      {display}
      {seperator}
      {crumb}
    </>
  ))
}

const CollapsedCrumbs = ({ breadcrumbs }: BreadcrumbsHeaderProps) => {
  const [first] = breadcrumbs
  const last = breadcrumbs[breadcrumbs.length - 1]
  const ellipsis = "..."
  return (
    <>
      {first}
      {seperator}
      {ellipsis}
      {seperator}
      {last}
    </>
  )
}

const Breadcrumbs = ({ breadcrumbs }: BreadcrumbsHeaderProps): JSX.Element => {
  return (
    useBreakpointComponent([
      <CrumbsContainer key={"small"}>
        {breadcrumbs.length > 2 ? (
          <CollapsedCrumbs breadcrumbs={breadcrumbs} />
        ) : (
          <AllCrumbs breadcrumbs={breadcrumbs} />
        )}
      </CrumbsContainer>,
      null,
      <CrumbsContainer key={"medium"}>
        {breadcrumbs.length > 3 ? (
          <CollapsedCrumbs breadcrumbs={breadcrumbs} />
        ) : (
          <AllCrumbs breadcrumbs={breadcrumbs} />
        )}
      </CrumbsContainer>,
      <CrumbsContainer key={"large"}>
        <AllCrumbs breadcrumbs={breadcrumbs} />
      </CrumbsContainer>
    ]) || <></>
  )
}

const BreadcrumbsHeader: FC<BreadcrumbsHeaderProps> = ({ breadcrumbs }) => {
  return (
    <Header>
      <Breadcrumbs breadcrumbs={breadcrumbs} />
    </Header>
  )
}

export const NewBreadcrumbsHeader: any = ({ breadcrumbs }: any) => {
  return (
    <FlexContainer height={"100%"} direction={"column"} justifyContent={"flex-end"}>
      <Container>
        <Breadcrumbs breadcrumbs={breadcrumbs} />
        <Container padding="8px 0px 0px 0px">
          <Divider />
        </Container>
      </Container>
    </FlexContainer>
  )
}

export default BreadcrumbsHeader
